import { createFeatureSelector, createSelector } from '@ngrx/store';
import { COLLECTIONS_FEATURE_KEY, CollectionsState } from './collections.reducer';

export const selectCollectionsState = createFeatureSelector<CollectionsState>(COLLECTIONS_FEATURE_KEY);

export const selectCollections = createSelector(selectCollectionsState, (state: CollectionsState) => state.collections);

export const selectBookmarkCount = createSelector(
  selectCollectionsState,
  (state: CollectionsState) => state.bookmarkCount,
);

export const selectCollectionsLoaded = createSelector(
  selectCollectionsState,
  (state: CollectionsState) => state.loaded,
);

export const selectCollectionsError = createSelector(selectCollectionsState, (state: CollectionsState) => state.error);

export const selectCollectionById = (id: number) =>
  createSelector(selectCollections, (collections) => collections.find((collection) => collection.id === id));
